import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { actions as plantActions } from './store/slice';

const { setSearchText } = plantActions;

const PlantSearch = () => {
  const dispatch = useDispatch();
  const [searchText, setSearchTextValue] = useState('');

  const handleSearch = e => {
    const newSearchText = e.target.value;
    setSearchTextValue(newSearchText);
    dispatch(setSearchText(newSearchText));
  };

  return (
    <div className="d-flex w-100">
      <div className="search-set">
        <div className="search-input">
          <Link to="#" className="btn btn-searchset">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={24}
              height={24}
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth={2}
              strokeLinecap="round"
              strokeLinejoin="round"
              className="feather feather-search"
            >
              <circle cx={11} cy={11} r={8} />
              <line x1={21} y1={21} x2="16.65" y2="16.65" />
            </svg>
          </Link>
          <div id="DataTables_Table_0_filter" className="dataTables_filter">
            <label>
              {' '}
              <input
                type="search"
                className="form-control form-control-sm"
                placeholder="Search"
                aria-controls="DataTables_Table_0"
                value={searchText}
                onChange={handleSearch}
              />
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PlantSearch;
